const SITE_NAME = '柿子AI科技'

const DEFAULT_SEO = {
  title: `${SITE_NAME} - 知识产权全周期一站式智能辅助平台 | 专利挖掘·撰写·答OA`,
  description:
    '柿子科技运用领先 AI 技术，提供专利挖掘、申请文件撰写、审查意见答复等知识产权全流程智能化解决方案，助力代理机构与企业高效完成专利工作。',
  keywords:
    '柿子AI科技,专利AI,知识产权,专利挖掘,专利撰写,答OA,专利申请,AI专利助手'
}

function upsertMeta(name: string, content: string, attr: 'name' | 'property' = 'name') {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, name)
    document.head.appendChild(el)
  }
  el.content = content
}

export function setPageSeo(options: {
  title?: string
  description?: string
  keywords?: string
} = {}) {
  const title = options.title || DEFAULT_SEO.title
  const description = options.description || DEFAULT_SEO.description
  const keywords = options.keywords || DEFAULT_SEO.keywords

  document.title = title
  upsertMeta('description', description)
  upsertMeta('keywords', keywords)
  upsertMeta('og:title', title, 'property')
  upsertMeta('og:description', description, 'property')
}

export function setPageTitle(pageTitle: string) {
  setPageSeo({ title: `${pageTitle} - ${SITE_NAME}` })
}

const JSON_LD_SCRIPT_ID = 'page-json-ld'

export function setJsonLd(id: string, data: Record<string, unknown>) {
  let el = document.head.querySelector<HTMLScriptElement>(`script[data-json-ld="${id}"]`)
  if (!el) {
    el = document.createElement('script')
    el.type = 'application/ld+json'
    el.setAttribute('data-json-ld', id)
    document.head.appendChild(el)
  }
  el.textContent = JSON.stringify(data)
}

export function removeJsonLd(id: string) {
  document.head.querySelector(`script[data-json-ld="${id}"]`)?.remove()
}

export { DEFAULT_SEO, JSON_LD_SCRIPT_ID, SITE_NAME }
